import { Tooltip } from '@arco-design/web-react'
import { MdOutlineAutoAwesome } from 'react-icons/md'
import useLocale from '@/utils/useLocale'

interface VideoAiButtonProps {
  size?: number
}

const VideoAiButton = ({ size = 32 }: VideoAiButtonProps) => {
  const t = useLocale()
  return (
    <Tooltip content={t['ai_script_extract']}>
      <div
        style={{
          width: size,
          height: size,
          background: 'linear-gradient(45deg, #4A00E0, #8E2DE2)',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(74, 0, 224, 0.5)',
          animation: 'pulse 2s infinite',
          cursor: 'pointer'
        }}
      >
        <MdOutlineAutoAwesome size={size * 0.6} color="#fff" />
      </div>
    </Tooltip>
  )
}

export default VideoAiButton
